export function query(param = null) {
  const url = window.location.href;
  const queryIndex = url.indexOf('?');

  const params =
    queryIndex === -1
      ? {}
      : decodeURI(window.location.href.substring(queryIndex))
          .replace('?', '')
          .split('&')
          .map(param => param.split('='))
          .reduce(
            (result, [key, value]) => ({
              ...result,
              [key]: value,
            }),
            {},
          );

  if (param) {
    return params[param];
  }

  return params;
}
